import { render, staticRenderFns } from "./infoAdvice.vue?vue&type=template&id=51a5f86e&scoped=true&ref=adminUser&"
import script from "./infoAdvice.vue?vue&type=script&lang=js&"
export * from "./infoAdvice.vue?vue&type=script&lang=js&"
import style0 from "./infoAdvice.vue?vue&type=style&index=0&id=51a5f86e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a5f86e",
  null
  
)

export default component.exports